// DO NOT EDIT -- generated from fs/services/llm-tool/admin.proto

import { AttributeSuggestionRecord, PageSpecSuggestion, PageSuggestionRecord } from './autoconfigure.proto';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';

export namespace LlmToolAdmin {

  export const DeleteAttributeSuggestionEndpoint = "/grpc/llm_tool.LlmToolAdmin/DeleteAttributeSuggestion";
  export function DeleteAttributeSuggestion(sender: (req: DeleteAttributeSuggestionRequest, endpoint: string) => Promise<DeleteAttributeSuggestionResponse>, req: DeleteAttributeSuggestionRequest): { promise: () => Promise<DeleteAttributeSuggestionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteAttributeSuggestionEndpoint),
      endpoint: DeleteAttributeSuggestionEndpoint
    };
  }

  export const DeleteAttributeSuggestionsEndpoint = "/grpc/llm_tool.LlmToolAdmin/DeleteAttributeSuggestions";
  export function DeleteAttributeSuggestions(sender: (req: DeleteAttributeSuggestionsRequest, endpoint: string) => Promise<DeleteAttributeSuggestionsResponse>, req: DeleteAttributeSuggestionsRequest): { promise: () => Promise<DeleteAttributeSuggestionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteAttributeSuggestionsEndpoint),
      endpoint: DeleteAttributeSuggestionsEndpoint
    };
  }

  export const DeleteSampleValuesEndpoint = "/grpc/llm_tool.LlmToolAdmin/DeleteSampleValues";
  /**
   * DeleteSampleValues enumerates through all attribute suggestions and deletes sample values that have a matching indvId, userId, or sessionId
   * If there is a matching value, the suggestion will be rewritten with the sample value removed, including the ingestion-settings record
   */
  export function DeleteSampleValues(sender: (req: DeleteSampleValuesRequest, endpoint: string) => Promise<DeleteSampleValuesResponse>, req: DeleteSampleValuesRequest): { promise: () => Promise<DeleteSampleValuesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSampleValuesEndpoint),
      endpoint: DeleteSampleValuesEndpoint
    };
  }

  export const BackfillSuggestedElementAutoWatchEndpoint = "/grpc/llm_tool.LlmToolAdmin/BackfillSuggestedElementAutoWatch";
  /** BackfillSuggestedElementAutoWatch backfills the AutoWatch field for suggested elements */
  export function BackfillSuggestedElementAutoWatch(sender: (req: BackfillSuggestedElementAutoWatchRequest, endpoint: string) => Promise<BackfillSuggestedElementAutoWatchResponse>, req: BackfillSuggestedElementAutoWatchRequest): { promise: () => Promise<BackfillSuggestedElementAutoWatchResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BackfillSuggestedElementAutoWatchEndpoint),
      endpoint: BackfillSuggestedElementAutoWatchEndpoint
    };
  }

  export const DeletePageSuggestionEndpoint = "/grpc/llm_tool.LlmToolAdmin/DeletePageSuggestion";
  export function DeletePageSuggestion(sender: (req: DeletePageSuggestionRequest, endpoint: string) => Promise<DeletePageSuggestionResponse>, req: DeletePageSuggestionRequest): { promise: () => Promise<DeletePageSuggestionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeletePageSuggestionEndpoint),
      endpoint: DeletePageSuggestionEndpoint
    };
  }

  export const DeletePageSuggestionsEndpoint = "/grpc/llm_tool.LlmToolAdmin/DeletePageSuggestions";
  export function DeletePageSuggestions(sender: (req: DeletePageSuggestionsRequest, endpoint: string) => Promise<DeletePageSuggestionsResponse>, req: DeletePageSuggestionsRequest): { promise: () => Promise<DeletePageSuggestionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeletePageSuggestionsEndpoint),
      endpoint: DeletePageSuggestionsEndpoint
    };
  }

  export const HandleSpecPageSuggestionsEndpoint = "/grpc/llm_tool.LlmToolAdmin/HandleSpecPageSuggestions";
  export function HandleSpecPageSuggestions(sender: (req: HandleSpecPageSuggestionsRequest, endpoint: string) => Promise<HandleSpecPageSuggestionsResponse>, req: HandleSpecPageSuggestionsRequest): { promise: () => Promise<HandleSpecPageSuggestionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, HandleSpecPageSuggestionsEndpoint),
      endpoint: HandleSpecPageSuggestionsEndpoint
    };
  }
}

export interface DeleteAttributeSuggestionRequest {
  orgId: string;
  id: string;
  commit: boolean;
}

export interface DeleteAttributeSuggestionResponse {
  attribute: AttributeSuggestionRecord | null;
}

export interface DeleteAttributeSuggestionsRequest {
  orgId: string;
  timeStart: protobuf.timestamp | null;
  timeEnd: protobuf.timestamp | null;
  commit: boolean;
}

export interface DeleteAttributeSuggestionsResponse {
  attributes: AttributeSuggestionRecord[];
}

export interface Session {
  userId: protobuf.int64;
  sessionId: protobuf.int64;
}

export interface UserIds {
  userIds: protobuf.int64[];
}

export interface DeleteSampleValuesRequest {
  userIds?: UserIds | null;
  session?: Session | null;
  orgId: string;
  commit: boolean;
}

export namespace DeleteSampleValuesRequest {
  export enum id {
    userIds = 1,
    session = 2
  }

  export function id_oneof(m: DeleteSampleValuesRequest): { opt: id.session, val: Session } | { opt: id.userIds, val: UserIds } | null {
    if (m.userIds != null) { return { opt: id.userIds, val: m.userIds } }
    if (m.session != null) { return { opt: id.session, val: m.session } }
    return null;
  }
}

export interface DeleteSampleValuesResponse {
  /** ids of records stored in llm-tool */
  updatedAttrIds: string[];
  /** ids of records stored in ingestion-settings */
  updatedRuleIds: protobuf.int64[];
}

export interface BackfillSuggestedElementAutoWatchRequest {
  orgId: string;
  commit: boolean;
}

export interface BackfillSuggestedElementAutoWatchResponse {
  suggestions: search_settings.Suggestion[];
}

export interface DeletePageSuggestionRequest {
  orgId: string;
  id: string;
  commit: boolean;
}

export interface DeletePageSuggestionResponse {
  page: PageSuggestionRecord | null;
}

export interface DeletePageSuggestionsRequest {
  orgId: string;
  timeStart: protobuf.timestamp | null;
  timeEnd: protobuf.timestamp | null;
  commit: boolean;
}

export interface DeletePageSuggestionsResponse {
  pages: PageSuggestionRecord[];
}

export interface HandleSpecPageSuggestionsRequest {
  orgId: string;
  /** whether to auto-approve the spec suggestion. */
  commit: boolean;
}

export interface HandleSpecPageSuggestionsResponse {
  suggestions: PageSpecSuggestion[];
}
